var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "master_svg0_173_25110"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 22,
    height: 22,
    rx: 0
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#master_svg0_173_25110)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.3108616,13.7296658L12.6552849,14.954921C12.500248,15.06966,12.2904968,15.084724,12.1229062,14.989252C10.1110229,13.843132,8.449774,12.0721407,7.3620946,9.9204288C7.2815363,9.7610636,7.297538299999999,9.571759700000001,7.3985591,9.4245129L8.6962762,7.5329754C8.7837486,7.405476800000001,8.8073125,7.2446816,8.760101800000001,7.0974455L7.8782856,4.34733263C7.8119283,4.14038475,7.6194894,4,7.402163,4L5.00000012,4C4.72385764,4,4.49920006748,4.22772563,4.5081975441,4.50372142C4.62401563,8.0564179,5.9636354,11.3739944,8.3081775,13.8988857C10.645814900000001,16.416342,13.7151842,17.857938,17.003118,17.990036C17.279037000000002,18.00112,17.5,17.776142,17.5,17.5L17.5,14.912205C17.5,14.695837,17.36083,14.504019,17.155141999999998,14.436883L14.763445,13.65625C14.609592,13.6060333,14.4409504,13.6333895,14.3108616,13.7296658",
    fill: "#C6CAD1",
    fillOpacity: 1,
    style: {
      mixBlendMode: "passthrough"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.9449574378ae7a73f781d894e6efb236.svg";
export { ForwardRef as ReactComponent };